import {
  blogCreateApi,
  blogDeleteApi,
  blogDetailApi,
  blogEditApi,
  blogListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { blogActions } from "./actions";

export function* blogSaga() {
  yield takeEveryFsa(blogActions.fetchBlogs.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.fetchBlogs, blogListApi);
  });

  yield takeEveryFsa(blogActions.getBlogDetails.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.getBlogDetails, blogDetailApi);
  });

  yield takeEveryFsa(blogActions.createNewBlog.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.createNewBlog, blogCreateApi);
  });

  yield takeEveryFsa(blogActions.updateBlog.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.updateBlog, blogEditApi);
  });

  yield takeEveryFsa(blogActions.deleteBlog.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.deleteBlog, blogDeleteApi);
  });
}
